import axios from "axios";

const baseURL = "https://realtime.shipday.com/";

const RealTimeClient = axios.create({
    baseURL: baseURL
});

export default RealTimeClient; 
